import React from 'react';
import { components } from 'react-select';
import _get from 'lodash/get';
import _size from 'lodash/size';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import { SELECT_ALL_OPTION_ID } from '../stubs';

export default function SelectOption(props) {
  const {
    isMulti,
    data,
    value,
    getValue,
    isDisabled,
    innerProps,
    selectProps: { isNested, allOptions },
    children
  } = props;
  let { isSelected } = props;

  const onItemClick = _get(innerProps, 'onClick', false);
  const isItemDisabled = _get(data, 'isDisabled', false);
  const disabled = isDisabled || isItemDisabled;
  const isSelectAllOption = value === SELECT_ALL_OPTION_ID;

  if (isSelectAllOption) {
    const selectedOptions = getValue();
    const allValidOptions = allOptions.slice(1); // discarding the "Select All" option
    isSelected = _size(selectedOptions) === _size(allValidOptions);
  }

  return (
    <components.Option
      {...props}
      isSelected={isSelected}
      isDisabled={disabled}
      innerProps={{ ...innerProps, onClick: disabled ? () => {} : onItemClick }}
    >
      <If test={isMulti}>
        <UiKit.Checkbox
          label={children}
          checked={isSelected}
          className={styles.multiOptionCheckbox}
        />
      </If>
      <If test={!isMulti}>
        <If test={isNested} otherwise={children}>
          <UiKit.Radio.Group value={isSelected}>
            <UiKit.Radio.Option label={children} value={true} />
          </UiKit.Radio.Group>
        </If>
      </If>
    </components.Option>
  );
}
